<template>
  <div>
    <b-row>
      <b-col md="3" lg="3" xl="3">
        <b-button-group size="sm">
          <b-button class="mb-2" variant="outline-success" @click="fromLoad('type_add')" v-if="allow('A')">
            <b-icon-plus></b-icon-plus>
            {{$l('tips_type_add') || '新增类型'}}
          </b-button>
        </b-button-group>
        <b-table
            hover
            show-empty
            responsive
            selectable
            ref="typeTable"
            select-mode="single"
            class="bg-white"
            head-variant="light"
            :busy="typeLoading"
            :fields="typeTableDataFields"
            :items="typeTableData"
            @row-selected="typeClick"
        >
          <template v-slot:cell(resAttributeType)="{ item }">
            <div>
              <b-icon class="mr-1" icon="folder-fill" variant="warning"></b-icon>
              <span>{{item.resAttributeTypeName?item.resAttributeTypeName:'--'}}({{item.resAttributeType?item.resAttributeType:'--'}})</span>
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center;">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
            </div>
          </template>
        </b-table>
      </b-col>
      <b-col md="9" lg="9" xl="9">
        <b-button-group size="sm">
          <b-button class="mb-2" variant="outline-success" @click="fromLoad('add')" v-if="allow('A')">
            <b-icon-plus></b-icon-plus>
            {{$l('tips_add') || '新增属性'}}
          </b-button>
        </b-button-group>
        <b-table
            responsive
            :busy="loading"
            ref="table"
            :fields="tableDataFields"
            :items="tableData"
            head-variant="light"
            hover
            class="bg-white"
            show-empty
            sort-icon-left
        >
          <template v-slot:cell(resAttributeStatus)="data">
            <b-badge
                :variant="data.item.resAttributeStatus === 'Y'?'success':'danger'"
            >{{data.item.resAttributeStatus === 'Y'?'有效':'无效'}}</b-badge>
          </template>
<!--          <template v-slot:cell(modifyInfo)="data">-->
<!--            <div>-->
<!--              <span>修改人: {{data.item.modifyByName}}</span>-->
<!--              <br />-->
<!--              <span>修改日期: {{data.item.modifyDate}}</span>-->
<!--            </div>-->
<!--          </template>-->
          <template v-slot:cell(operation)="data">
            <b-button-group>
              <b-button
                  class="mr-2"
                  v-b-tooltip.hover
                  :title="$l('tips_view')||'查看'"
                  @click="fromLoad('detail', data.item.resAttributeCode)"
                  variant="outline-secondary"
                  size="sm"
              >
                <b-icon-eye></b-icon-eye>
              </b-button>
              <b-button
                  class="mr-2"
                  v-b-tooltip.hover
                  :title="$l('tips_edit')||'编辑'"
                  @click="fromLoad('edit', data.item.resAttributeCode)"
                  variant="outline-secondary"
                  size="sm"
                  v-if="allow('M')"
              >
                <b-icon-pencil></b-icon-pencil>
              </b-button>
              <b-button
                  v-b-tooltip.hover
                  :title="$l('tips_del')||'删除'"
                  :disabled="data.item.resAttributeStatus === 'N' "
                  @click="del([data.item.resAttributeCode])"
                  variant="outline-secondary"
                  size="sm"
                  v-if="allow('D')"
              >
                <b-icon-trash-fill></b-icon-trash-fill>
              </b-button>
            </b-button-group>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center;">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <page-detail ref="form" :params="params" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{$l('form_button_cancel')||'取 消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >{{$l('form_button_save')||'保 存'}}</el-button>
      </div>
    </el-dialog>
    <!--属性类型新增-->
    <el-dialog
        ref="typeFormDialog"
        :title="typeFormOption.title"
        :visible.sync="typeFormOption.dialogFormVisible"
        :before-close="cancel"
        @closed="typeClosed"
        :close-on-click-modal="false"
        width="400px"
    >
      <type-add ref="typeForm" @success="typeSaveSuccess"></type-add>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeCancel" size="small">{{$l('form_button_cancel')||'取 消'}}</el-button>
        <el-button
            type="primary"
            @click="typeSave"
            size="small"
        >{{$l('form_button_save')||'保 存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => []
    },
    typeTableData: {
      default: () => []
    },
    loading: {
      default: false
    },
    typeLoading:{
      default: false
    }
  },
  components: {
    PageDetail: () => import("./components/detail"),
    TypeAdd: () => import("./components/typeAdd")
  },
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 属性类型表单设置
      typeFormOption: {
          title: "",
          dialogFormVisible: false,
          dialogSaveBtnVisible: true,
      },
      params:{
        resAttributeType: ''
      },
      typeTableDataFields: [{
          key: "resAttributeType",
          label: this.$l("table_label_attribute_type") || "属性类型",
          tdClass: "align-middle"
      }],
      tableDataFields: [
        {
          key: "resAttributeType",
          label: this.$l("table_label_attribute_type") || "属性类型",
          tdClass: "align-middle",
        },
        {
          key: "resAttributeName",
          label: this.$l("table_label_name_cn") || "中文名称",
          tdClass: "align-middle",
        },
        {
          key: "resAttributeNameEn",
          label: this.$l("table_label_name_en") || "英文名称",
          tdClass: "align-middle",
        },
        {
          key: "resAttributeStatus",
          label: this.$l("table_label_status") || "有效状态",
          tdClass: "align-middle",
        },
        {
          key: "resAttributeDescription",
          label: this.$l("table_label_attribute_description") || "属性说明",
          tdClass: "align-middle",
        },
        // {
        //   key: "modifyInfo",
        //   label: this.$l("table_label_modifyInfo") || "修改信息",
        //   tdClass: "align-middle",
        // },
        {
          key: "operation",
          label: this.$l("table_label_operation") || "操作",
          tdClass: "align-middle",
        },
      ],
    };
  },
  methods: {
    typeClick(val){
      if(val[0]) {
        this.params = {
          resAttributeType: val[0].resAttributeType
        }
      }else {
        this.params = {
          resAttributeType: ''
        }
      }
      this.$emit('typeClick',this.params)
    },
    clearSelected() {
        this.$refs.typeTable.clearSelected()
    },
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      let key;
      if(ref === 'type_add') {
        key = "tips_add";
        this.typeFormOption.title = this.$l(key) || opt['add'];
        this.typeFormOption.dialogFormVisible = true;
        return
      } else if (ref === "add") {
        if(!this.params.resAttributeType) {
          this.$message.warning(this.$l('tips_select_left_attribute_type')||'请选择左侧属性类型!')
          return
        }
        key = "tips_add";
      } else if (ref === "edit") {
        key = "tips_edit";
      } else if (ref === "detail") {
        key = "tips_view";
      }
      // 设置标题
      this.formOption.title = this.$l(key) || opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
    typeSave() {
        this.$refs.typeForm.save();
    },
    typeSaveSuccess() {
        this.typeCancel();
        this.$emit("typeSubmit");
    },
    typeCancel() {
        this.typeFormOption.dialogFormVisible = false;
    },
    typeClosed () {
        this.$refs.typeForm.init();
    },
    delRows() {
        let selection = this.selected;
        if (!selection || selection.length < 1) {
            this.$message.warning(this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据");
            return;
        }
        let tempArray = [];
        selection.forEach((item) => {
            tempArray.push(item.resAttributeCode);
        });
        this.del(tempArray);
    },
    del(resAttributeCodeList) {
        this.$confirm(
            this.$l("INDEX.tips_question_delete") || "是否删除？",
            this.$l("INDEX.tips_question_title") || "提示",
            {
                confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
                cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
                type: "warning",
            }
        ).then(() => {
            this.$api.delResearchDictionaryApi({ resAttributeCodeList }).then(() => {
                this.$message.success(this.$l("INDEX.tips_delete_ok") || "删除成功！");
                this.$emit("submit");
            });
        });
    },
    onRowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.indeterminate = false;
        this.allChecked = false;
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false;
        this.allChecked = true;
      } else {
        this.indeterminate = true;
        this.allChecked = false;
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index);
      if (isRowSelected) {
        this.$refs.table.unselectRow(index);
      } else {
        this.$refs.table.selectRow(index);
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows();
      } else {
        this.$refs.table.clearSelected();
      }
    },
  },
};
</script>
